//@ts-expect-error not typed
import { HIDDEN } from 'crm_data/pipelinePermissions/pipelinePermissionsConstants';
export const getCanAccessPipeline = pipeline => {
  const accessLevel = pipeline && pipeline.permission && pipeline.permission.accessLevel && pipeline.permission.accessLevel;
  return accessLevel !== HIDDEN;
};